import { data } from "jquery";
import { deleteRequest, getRequest, postRequest } from "../../config/AxiosConfig";
import API_URLS from "../../config/BackendConfig";
import { getAuthToken, getToken } from "../../utils/tokenUtils";


export const verifyPanDetail = async (payload) => {
    try {
        const response = await postRequest({
            url: API_URLS.ADMIN + "validate-pan",
            data: payload,
            headers: { Authorization: `Bearer ${getAuthToken()}` },
        });

        return response;
    } catch (error) {
        return error;
    }
};

export const verifyBusinessPanDetail = async (payload) => {
    try {
        const response = await postRequest({
            url: API_URLS.ADMIN + "validate/company-pan",
            data: payload,
            headers: { Authorization: `Bearer ${getAuthToken()}` },
        });

        return response;
    } catch (error) {
        return error;
    }
};


export const verifyCin = async (payload) => {
    try {
        const response = await postRequest({
            url: API_URLS.ADMIN + "validate/cin",
            data: payload,
            headers: { Authorization: `Bearer ${getAuthToken()}` },
        });

        return response;
    } catch (error) {
        return error;
    }
};

export const verifyGst = async (payload) => {
    try {
        const response = await postRequest({
            url: API_URLS.ADMIN + "validate/gst",
            data: payload,
            headers: { Authorization: `Bearer ${getAuthToken()}` },
        });

        return response;
    } catch (error) {
        return error;
    }
};

export const createNewPartner = async (payload) => {
    try {
        const response = await postRequest({
            url: API_URLS.ADMIN + "register-partner",
            data: payload,
            headers: {
                Authorization: `Bearer ${getAuthToken()}`,
                "Content-Type": "multipart/form-data",
            },
        });

        return response;
    } catch (error) {
        return error;
    }
};